import { RegisterFormQuestion } from '@/modules/FinancialPlanning/interface/RegisterForm';

export const formQuestions: { [key: number]: RegisterFormQuestion[] } = {
  '1': [
    {
      id: 'gender',
      text: 'Informe o seu gênero.',
      options: [
        { name: 'Masculino', value: 'MALE' },
        { name: 'Feminino', value: 'FEMALE' },
        { name: 'Prefiro não responder', value: 'OTHER' },
      ],
    },
  ],
  '2': [
    {
      id: 'maritalStatus',
      text: 'Qual o seu Estado Civil?',
      options: [
        { name: 'Solteiro(a)', value: 'SINGLE' },
        { name: 'Casado(a)', value: 'MARRIED' },
        { name: 'União Estável', value: 'STABLE_UNION' },
        { name: 'Viúvo(a)', value: 'WIDOWED' },
        { name: 'Divorciado(a)', value: 'DIVORCED' },
      ],
    },
    {
      id: 'maritalRegime',
      text: 'Qual o seu Registro de Casamento?',
      options: [
        {
          name: 'Comunhão Parcial de Bens',
          value: 'LIMITED_COMMUNITY_PROPERTY',
        },
        {
          name: 'Comunhão Universal de Bens',
          value: 'UNIVERSAL_COMMUNITY_PROPERTY',
        },
        {
          name: 'Separação Total de Bens',
          value: 'TOTAL_SEPARATE_PROPERTY',
        },
        {
          name: 'Participação Final nos Aquestos',
          value: 'FINAL_PARTICIPATION_IN_THE_AQUES',
        },
      ],
    },
    {
      id: 'spouse',
      text: 'Preencha os dados do seu Cônjuge',
      fields: [
        { id: 'name', type: 'text', label: 'Nome' },
        {
          id: 'birthDate',
          type: 'date',
          label: 'Data de nascimento',
        },
        { id: 'document', type: 'text', label: 'CPF' },
        {
          id: 'gender',
          type: 'select',
          label: 'Sexo',
          options: [
            { name: 'Masculino', value: 'MALE' },
            { name: 'Feminino', value: 'FEMALE' },
            { name: 'Prefiro não responder', value: 'OTHER' },
          ],
        },
        {
          id: 'phoneNumber',
          type: 'text',
          label: 'Telefone',
        },
        { id: 'email', type: 'text', label: 'Email' },
      ],
    },
  ],
  '3': [
    {
      id: 'hasDependents',
      text: 'Você possui dependentes?',
      options: [
        { name: 'Não', value: 'false' },
        { name: 'Sim', value: 'true' },
      ],
    },
    {
      id: 'dependents',
      text: 'Preencha os dados dos seus dependentes',
      fields: [
        { id: 'name', type: 'text', label: 'Nome' },
        {
          id: 'kinship',
          type: 'select',
          label: 'Parentesco',
          options: [
            { name: 'Filho(a)', value: 'CHILD' },
            { name: 'Mãe', value: 'MOTHER' },
            { name: 'Pai', value: 'FATHER' },
            { name: 'Irmã(o)', value: 'SIBLING' },
            { name: 'Avô(ó)', value: 'GRANDPARENT' },
            { name: 'Neto(a)', value: 'GRANDCHILD' },
            { name: 'Sobrinho(a)', value: 'NEPHEW' },
            { name: 'Tio(a)', value: 'AUNT_UNCLE' },
            { name: 'Outro', value: 'OTHER' },
          ],
        },
        {
          id: 'gender',
          type: 'select',
          label: 'Sexo',
          options: [
            { name: 'Masculino', value: 'MALE' },
            { name: 'Feminino', value: 'FEMALE' },
            { name: 'Prefiro não responder', value: 'OTHER' },
          ],
        },
        {
          id: 'birthDate',
          type: 'date',
          label: 'Data de nascimento',
        },
      ],
    },
  ],
};
